<app-application-template-form-dialog
    [isModification]="true"
    [form]="form"
    (submission)="saveTemplate()"
    (closeDialog)="closeDialog()"
    (checkTemplateNameExistence)="checkTemplateNameExistence()"
    class="h-full"
>
    ></app-application-template-form-dialog
>
